const RTL_LOCALES = ['ar', 'fa', 'he'];
export function getTextDirection(locale: string): 'ltr' | 'rtl' {
  const localeObject = new Intl.Locale(locale);
  if ('textInfo' in localeObject) {
    return (localeObject.textInfo as any).direction;
  }
  return RTL_LOCALES.includes(localeObject.language) ? 'rtl' : 'ltr';
}
